<template>
  <div class="q-pa-md">
    <q-card class="lista-participante-card">
      <q-card-section>
        <div class="text-h5 text-green-14">Dados Principais</div>
      </q-card-section>
      <q-card-section>
        <form @submit.prevent.stop="verificar">
          <div class="row q-gutter-lg q-pr-md">
            <div class="col-xs-12 col-sm-12 col-md-3">
              <b-input-cpf ref="identificao_fical" label="CPF *" v-model="dadosPrincipal.identificacaoFiscal" outlined
                :dense="true" lazy-rules :rules="[vRequired]" />
            </div>
            <div class="col-xs-12 col-sm-12 col-md-3">
              <q-input ref="matricula" type="number" label="Matrícula" v-model="dadosPrincipal.matricula" outlined
                :dense="true" lazy-rules />
            </div>
            <div class="col-xs-12 col-sm-12 col-md-3">
              <q-input outlined :dense="true" ref="data_nascimento" lazy-rules :rules="[(val) => validaData(val)]"
                label="Data de Nascimento *" v-model="dadosPrincipal.dataNascimento" mask="##/##/####">
                <template v-slot:append>
                  <q-icon name="event" class="cursor-pointer">
                    <q-popup-proxy ref="qDateProxy" transition-show="scale" transition-hide="scale">
                      <q-date color="primary" v-model="dadosPrincipal.dataNascimento" mask="DD/MM/YYYY"
                        @input="() => $refs.qDateProxy.hide()" />
                    </q-popup-proxy>
                  </q-icon>
                </template>
              </q-input>
            </div>
            <div class="col-xs-12 col-sm-12 col-md-3">
              <q-input ref="telefone" type="tel" label="Telefone *" v-model="dadosPrincipal.telefone" outlined
                :dense="true" lazy-rules :rules="[vRequired]" mask="###########"/>
            </div>
            <div class="col-xs-12 col-sm-12 col-md-3">
              <q-input ref="email" type="email" label="Email *" v-model="dadosPrincipal.email" outlined :dense="true"
                lazy-rules :rules="[vRequired, isValidEmail]" />
            </div>
          </div>
          <div class="row q-gutter-lg q-pr-md">
            <div class="col-xs-12 col-sm-12 col-md-3">
              <vue-recaptcha ref="recaptcha" :sitekey="siteKey" :loadRecaptchaScript="true" @verify="onVerify"
                @expired="onExpired" style="padding-top: 16px;"></vue-recaptcha>
            </div>
            <div class="col-xs-12 col-sm-12 col-md-6 q-pt-lg" style="margin-top:30px;">
              <q-btn v-if="gRecaptchaResponse" :loading="loadingVerificar" color="primary" label="Consultar" type="submit" />
            </div>
            <div class="row q-gutter-lg q-pr-md">
              <ConfirmacaoLoginComponent :identificacaoFiscal="dadosPrincipal.identificacaoFiscal" :v-if="modalLogin && dadosPrincipal.identificacaoFiscal" :modalLogin="modalLogin" />
            </div>
          </div>
        </form>
      </q-card-section>
    </q-card>
  </div>
</template>
<style></style>

<script>
import DadosPrincipal from '@/classes/DadosPrincipal'
import ConfirmacaoLoginComponent from '@/views/login/ConfirmacaoLogin'
import AuthService from '@/services/auth'
// import CPFValidator from '@/utils/CPFValidator'
import Mixins from '@/mixins/Mixins.js'
import VueRecaptcha from 'vue-recaptcha'
export default {
  data () {
    return {
      dadosPrincipal: new DadosPrincipal(),
      loadingVerificar: false,
      gRecaptchaResponse: null,
      siteKey: '6LceAR8sAAAAAIN19FgqUEmj0WfdMedjY3LKlNH-',
      modalLogin: false
    }
  },
  mixins: [Mixins],
  components: {
    VueRecaptcha,
    ConfirmacaoLoginComponent
  },
  mounted () {
    this.init()
    this.resetRecaptcha()
  },
  methods: {
    init () {
      localStorage.removeItem('Token_CAPAF')
    },
    verificar () {
      if (!this.gRecaptchaResponse || this.gRecaptchaResponse === undefined) {
        this.$b.nError('O Captcha deve ser preenchido!')
        return
      }
      if ((this.dadosPrincipal.identificacaoFiscal === null && this.dadosPrincipal.dataNascimento === null) ||
        (this.dadosPrincipal.identificacaoFiscal === '' && this.dadosPrincipal.dataNascimento === '')) {
        return this.$b.nWarning('Informe o cpf e a data de nascimento')
      }
      if (this.dadosPrincipal.identificacaoFiscal === null || this.dadosPrincipal.identificacaoFiscal === '') {
        return this.$b.nWarning('Informe o cpf')
      }
      if (this.dadosPrincipal.dataNascimento === null || this.dadosPrincipal.dataNascimento === '') {
        return this.$b.nWarning('Informe a Data de Nascimento')
      }
      if (this.dadosPrincipal.email === null || this.dadosPrincipal.email === '') {
        return this.$b.nWarning('Informe o email')
      }
      if (this.dadosPrincipal.telefone === null || this.dadosPrincipal.telefone === '' || this.dadosPrincipal.telefone.length !== 11) {
        return this.$b.nWarning('O telefone deve ter o seguinte formato "99999999999"')
      }
      /*       if (!CPFValidator(this.dadosPrincipal.identificacaoFiscal)) {
        return this.$b.nError('CPF inválido')
      } */
      if (this.dadosPrincipal.matricula === '') {
        this.dadosPrincipal.matricula = null
      }
      var dadosPrincipal = Object.assign({}, this.dadosPrincipal)
      dadosPrincipal.dataNascimento = this.invertDate(dadosPrincipal.dataNascimento)
      this.loadingVerificar = true
      AuthService.usuarioExiste(dadosPrincipal, this.gRecaptchaResponse).then(resposta => {
        this.loadingVerificar = false
        this.resetRecaptcha()
        if (resposta.data.status === 'TOKEN_INVALIDO') {
          return this.$b.nError(resposta.data.message)
        }
        if (resposta.data.status === 'ERROR') {
          return this.$b.nError(resposta.data.message)
        }
        this.eventModalLogin(true)
        this.$b.nSuccess('Consulta realizada com sucesso')
      }).catch((e) => {
        this.eventModalLogin(null)
        this.loadingVerificar = false
        return this.$b.nError(e)
      })
    },
    eventModalLogin (value) {
      this.modalLogin = value
    },
    resetRecaptcha () {
      this.$refs.recaptcha.reset() // Direct call reset method
      this.gRecaptchaResponse = null
      this.loadingVerificar = false
    },
    onExpired: function () {
      this.gRecaptchaResponse = null
      this.loadingVerificar = false
    },
    onVerify (token) {
      this.gRecaptchaResponse = token
      this.loadingVerificar = false
    },
    validaData (data) {
      if (typeof data !== 'string') return false

      // formato dd/mm/yyyy
      const regex = /^(\d{2})\/(\d{2})\/(\d{4})$/
      const match = data.match(regex)

      if (!match) return false

      const dia = parseInt(match[1], 10)
      const mes = parseInt(match[2], 10) - 1 // JS usa mês 0–11
      const ano = parseInt(match[3], 10)

      const dataObj = new Date(ano, mes, dia)

      // valida se a data criada é exatamente a informada
      return (
        dataObj.getFullYear() === ano &&
        dataObj.getMonth() === mes &&
        dataObj.getDate() === dia
      )
    }
  }
}
</script>
